

import Vue from 'vue';
import suid from '../../services/suid';

export default {
    name: 'KsTimerSlider',
    //isfree=false 默认 没有优惠  isfree=true买10赠2
    props: {
        value: {
            type: String,
            required: true,
            default: ""
        },
        isfree: {
            type:Boolean,
            required:true,
            default:false
        }
    },
    watch:{
        value(){
            if(this.onOff){
                return;
            }
            this.changVal('value');
        },
        isfree(){
            var $yearLi=$(this.$el).find('.ks-drag-left .year');
            var $gift=$(this.$el).find('.ks-drag-left .gift');
            if(!this.isfree){
                //$gift.hide();
                this.tipShow=false;
                //$yearLi.find('span').addClass("spanActive")
            }else{
                //$gift.show();
                if(this.value>10){
                    this.tipShow=true;
                }              
                //$yearLi.find('span').removeClass("spanActive")
            }
        }
    },

    computed: {
        options(){
            var arr=[1,2,3,4,5,6,7,8,9]
            return arr
        }
    },

    data() {
        return {
            lang: KSC_SECNET_CONSOLE.LANG,
            boxLeftOffset:0,
            number:10,
            tipShow:false,
            onOff:false
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.changVal('mouted')
           
        });
    },

    methods: {
        changVal(type){
            console.log(type,'typeee')
            var normalWidth=$(this.$el).find('.normal').outerWidth();
            var yearWidth=$(this.$el).find('.year').outerWidth();
            var halfWidthBtn=$(this.$el).find('.slider-btn').outerWidth()/2;
            var WidthBtn=$(this.$el).find('.slider-btn').outerWidth();
            var $yearLi=$(this.$el).find('.ks-drag-left .year');
            var $gift=$(this.$el).find('.ks-drag-left .gift');
            var $li=$(this.$el).find('.progressTimer .normal');
            var num=parseInt(this.value);
            var yearNum=parseInt(this.value/12)
            console.log(yearWidth,'yearwidth10101001')
             if(!this.isfree){
                //$gift.hide();
                this.tipShow=false;
                //$yearLi.find('span').addClass("spanActive")
            }else{
                //$gift.show();
                if(num>10){
                    this.tipShow=true;
                }              
                //$yearLi.find('span').removeClass("spanActive")
            }
            if(num<10){
                $(this.$el).find('.progressTimer').css('width',num*normalWidth-halfWidthBtn)
                $(this.$el).find('.slider-btn').css('left',num*normalWidth-halfWidthBtn)
                $li.find('.sub').hide();       
                $li.eq(num-1).find('.sub').show();     
            }else{
                $li.find('.sub').hide();  
                this.number=yearNum*10

                $(this.$el).find('.progressTimer').css('width',9*normalWidth+yearNum*yearWidth-halfWidthBtn)
                $(this.$el).find('.slider-btn').css('left',9*normalWidth+yearNum*yearWidth-halfWidthBtn)
            }       
        },
        mousedownHandler(e){
            e.preventDefault();
            this.onOff=true;
            this.$emit('isdown', true);
            $('body').addClass('ks-unselect');
            this.boxLeftOffset=$(this.$el).find('.ks-drag-left').offset().left;
            console.log(this.boxLeftOffset,'boxLeftOffset2222')
            var offsetLeft=e.clientX-this.boxLeftOffset;
            var data=this.returnTimerPos(offsetLeft);
            $(this.$el).find('.progressTimer').css('width',data.w);
            $(this.$el).find('.slider-btn').css('left',data.pos);
            
            if(data.i>9&&this.isfree==true){
                this.tipShow=true;
            }else{
                this.tipShow=false;
            }
            if(data.i>9){
                this.number=(data.i/12)*10
            }
          
            var $li=$(this.$el).find('.progressTimer .normal')
            $li.find('.sub').hide();
            if(data.i<10){               
                $li.eq(data.i-1).find('.sub').show();
            }
            //this.value=data.i+'';
            this.$emit('input', data.i + '');
         
            document.body.addEventListener('mousemove', this.mousemoveHandler, false);
            document.body.addEventListener('mouseup', this.removemoveHandler, false);
        },
        mousemoveHandler(e){
            e.preventDefault();
            this.$emit('isdown', true);
            var offsetLeft=e.clientX-this.boxLeftOffset;
            if(offsetLeft>0){
                var data=this.returnTimerPos(offsetLeft);               
            }else{
                var data={
                    i:1,
                    pos:0,
                    w:$(this.$el).find('.normal').outerWidth()
                }
            }

            $(this.$el).find('.progressTimer').css('width',data.w);
            $(this.$el).find('.slider-btn').css('left',data.pos);

            
            if(data.i>9&&this.isfree==true){
                this.tipShow=true;
            }else{
                this.tipShow=false;
            }
           if(data.i>9){
                this.number=(data.i/12)*10
            }

            var $li=$(this.$el).find('.progressTimer .normal')
            $li.find('.sub').hide();
            if(data.i<10){               
                $li.eq(data.i-1).find('.sub').show();
            }
            //this.value=data.i+'';
            this.$emit('input', data.i + '');
        },

        returnTimerPos(cur){
            var normalWidth=$(this.$el).find('.normal').outerWidth();
            var yearWidth=$(this.$el).find('.year').outerWidth();
            var yearfirst=$(this.$el).find('.yearfirst').outerWidth();
            var yearnormal=$(this.$el).find('.yearnormal').outerWidth();
            var halfWidthBtn=$(this.$el).find('.slider-btn').outerWidth()/2;
            var WidthBtn=$(this.$el).find('.slider-btn').outerWidth();
            var json={
                i:0, //返回哪个月
                pos:0, //返回btn的left值
                w:0   //返回刚按下的蓝色的宽度
            }
            var backLi = $(this.$el).find('.progressTimer ul').find('li');
            if(cur>$(this.$el).find('.w100 ul').width()-halfWidthBtn){
                cur=$(this.$el).find('.w100 ul').width()-halfWidthBtn;
            }
            for(var i=0;i<backLi.length;i++){
                var x1 = backLi[i].offsetLeft;
                var x2 = x1 + backLi[i].offsetWidth*(1/3);
                var x3 = x1 + backLi[i].offsetWidth*(2/3);
                var x4=x1+backLi[i].offsetWidth;
                var curLiContent = $(backLi[i]).text();
                console.log(i,'iiiii')
                //在li的左边部分 i-1 
                if(cur>=x1&&cur<x2){
                    if(i>8){
                        //有年
                        var y = parseInt(curLiContent);
                        if( y == 1){
                            json.i =parseInt(backLi[i-1].innerHTML);
                            json.w=json.i*normalWidth-halfWidthBtn;
                            json.pos=json.i*normalWidth-halfWidthBtn;
                        }else{
                            json.i = (y-1)*12; 
                            if(json.i==12){
                                json.w=9*normalWidth+1*yearfirst-halfWidthBtn;
                                json.pos=9*normalWidth+1*yearfirst-halfWidthBtn;
                            }
                            if(json.i==24){
                                json.w=9*normalWidth+yearfirst+yearnormal-halfWidthBtn;
                                json.pos=9*normalWidth+yearfirst+yearnormal-halfWidthBtn;
                            }
                        }
                    }else{
                        var y = parseInt(curLiContent);
                        if(y == 1){
                            json.i=y;
                            json.w=json.i*normalWidth;
                            json.pos=0;
                        }else{
                            json.i= y - 1;
                            json.w=json.i*normalWidth-halfWidthBtn;
                            json.pos=json.i*normalWidth-halfWidthBtn;
                        }
                    }
                }
                //在li的中间部分 i
                if(cur>=x2&&cur<=x3){
                    if(i>8){
                        //有年
                        var y = parseInt(curLiContent);           
                        json.i = y*12;                      
                        json.w=9*normalWidth+yearfirst+(y-1)*yearnormal;
                        json.pos=9*normalWidth+yearfirst+(y-1)*yearnormal-halfWidthBtn-($(backLi[i]).outerWidth())/2;                     
                    }else{
                        var y = parseInt(curLiContent);                     
                        json.i= y;
                        json.w=json.i*normalWidth;
                        json.pos=json.i*normalWidth-halfWidthBtn-normalWidth/2;                       
                    }
                }
                //在li的右半部分 i
                if(cur>x3&&cur<=x4){
                    if(i>8){
                        //有年
                        var y = parseInt(curLiContent);           
                        json.i = y*12; 
                        json.w=9*normalWidth+yearfirst+(y-1)*yearnormal;
                        json.pos=9*normalWidth+yearfirst+(y-1)*yearnormal-halfWidthBtn; 
                  }else{
                        var y = parseInt(curLiContent);                  
                        json.i= y;
                        json.w=json.i*normalWidth;
                        json.pos=json.i*normalWidth-halfWidthBtn;
                    }
                }               
            }
            return json;

        },
        removemoveHandler(e){
            this.onOff=false;
            this.$emit('isdown', false);
            var normalWidth=$(this.$el).find('.normal').outerWidth();
            var yearWidth=$(this.$el).find('.year').outerWidth();
            var yearfirst=$(this.$el).find('.yearfirst').outerWidth();
            var yearnormal=$(this.$el).find('.yearnormal').outerWidth();
            var halfWidthBtn=$(this.$el).find('.slider-btn').outerWidth()/2;
            var WidthBtn=$(this.$el).find('.slider-btn').outerWidth();
            var offsetLeft=e.clientX-this.boxLeftOffset;
            if(offsetLeft>0){
                var data=this.returnTimerPos(offsetLeft);               
            }else{
                var data={
                    i:1,
                    pos:0,
                    w:$(this.$el).find('.normal').outerWidth()
                }
            }
            if(data.i<10){
                $(this.$el).find('.slider-btn').css('left',data.i*normalWidth-halfWidthBtn)
            }else{
                var y=data.i/12;
                $(this.$el).find('.slider-btn').css('left',9*normalWidth+yearfirst+(y-1)*yearnormal-halfWidthBtn)
            }
            
            document.body.removeEventListener('mousemove', this.mousemoveHandler, false);
            document.body.removeEventListener('mouseup', this.removemoveHandler, false);
        }

    }


};